import { buildAttachmentAwareRequest } from 'repositories/utils/attachmentRequest'

import { berthApiClient } from '../berthApiClient'

import { updateRepeatBookingEndpoint } from './endpoint'
import type { UpdateRepeatBookingParams, UpdateRepeatBookingResponse } from './type'

export const updateRepeatBooking = async (
  params: UpdateRepeatBookingParams
): Promise<UpdateRepeatBookingResponse> => {
  const { body, config } = buildAttachmentAwareRequest(params)
  const res = await berthApiClient.put<UpdateRepeatBookingResponse>(
    updateRepeatBookingEndpoint,
    body,
    config
  )
  return res.data
}
